import styled from 'styled-components';

const Wrapper = styled.section`
  direction: rtl;
  min-height: 100vh;
  scroll-behavior: smooth;
  display: grid;
  align-items: center;
  padding: 1rem;

  .logo {
    display: block;
    margin: 0 auto;
    margin-bottom: 1.38rem;
  }

  .form {
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;
    border-top: 5px solid var(--primary-500);
  }

  .form-title {
    text-align: center;
    margin-bottom: 1rem;
    font-size: 1.8rem;
  }

  h4 {
    text-align: center;
    margin-bottom: 1.38rem;
  }

  p {
    margin-top: 1rem;
    text-align: center;
    line-height: 1.5;
    font-size: 1rem;
  }

  .btn {
    margin-top: 1rem;
  }

  .member-btn {
    color: var(--primary-500);
    letter-spacing: var(--letter-spacing);
    margin-left: 0.25rem;
    font-size: 1rem;
  }

  .terms-box {
    width: 100%;
    height: 200px;
    overflow-y: scroll;
    border: 1px solid gray;
    margin-bottom: 1rem;
    padding: 0.5rem;
    font-size: 0.9rem;
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .role-selection {
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
  }

  .role-cards {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
  }

  .card {
    width: 30%; /* שליש מהמסך במחשב */
    padding: 1rem;
    border: 1px solid var(--primary-500);
    border-radius: 8px;
    cursor: pointer;
    margin: 0.5rem;
    transition: all 0.3s ease-in-out;
    text-align: center;
  }

  .card.selected {
    background-color: var(--primary-500);
    color: white;
  }

  .card h6 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
  }

  .card p {
    font-size: 0.9rem;
  }

  @media (max-width: 768px) {
    .form {
      max-width: 90%;
    }
    .role-cards {
      flex-direction: column;
      align-items: center;
    }
    .card {
      width: 90%;
    }
    .form-title {
      font-size: 1.5rem;
    }
    .card h6 {
      font-size: 1.1rem;
    }
    .card p {
      font-size: 0.85rem;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .form {
      max-width: 80%;
    }
    .role-cards {
      flex-direction: row;
    }
    .card {
      width: 45%;
    }
  }
`;

export default Wrapper;
